import { FormControl, MenuItem, OutlinedInput, Select } from '@mui/material'
import { ErrorMessage } from 'formik'
import React from 'react'

const CustomSelect = ({options,value,label,handleChange,showError,error,isMultiple=false,...props}) => {
  const selectValue =
    value === undefined || value === null || value === '' ? '' : value
  return (
    <div>
         <FormControl sx={{m: 0, width: '100%'}}>
                {/* <InputLabel id="demo-multiple-chip-label">Chip</InputLabel> */}
                <div className="single-select-chip">
                  <label htmlFor="demo-simple-select-label">{label}</label>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select-label"
                    name="demo-simple-select-label"
                    value={selectValue}
                    onChange={handleChange}
                    style={{width: '100%'}}
                    multiple={isMultiple}
                    //   input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                    // renderValue={value => value.fullname || value.name}
                    // MenuProps={MenuProps}
                    {...props}
                    >
                    {options.map((item,index) => (
                      <MenuItem
                        key={index}
                        value={item?.value}
                        // style={getStyles(item.name, personName, theme)}
                      >
                        {item?.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* {showError && (
                    <ErrorMessage component="div" name={error} className="error" />
                  )} */}
                </div>
              </FormControl>
    </div>
  )
}

export default CustomSelect